import {
  type InvestmentEntity,
  InvestmentEntityStatus,
  InvestmentEntityTradability,
  InvestmentEntityType,
  InvestmentEntityVisibility,
} from '@cash-web/protos/squareup/cash/marketdata/model/investment_entities.pb'

export const isTradableInvestmentEntity = ({ type, status, visibility, tradability }: InvestmentEntity) =>
  (type === InvestmentEntityType.STOCK || type === InvestmentEntityType.ETF) &&
  status === InvestmentEntityStatus.ACTIVE &&
  visibility === InvestmentEntityVisibility.VISIBLE &&
  tradability === InvestmentEntityTradability.TRADABLE

export const matchesInvestmentEntitySearch = ({ display_name, symbol }: InvestmentEntity, searchText: string) => {
  const searchTextLower = searchText.toLowerCase()
  return Boolean(
    symbol?.toLowerCase().includes(searchTextLower) || display_name?.toLowerCase().includes(searchTextLower)
  )
}

export const compareInvestmentEntitiesByDisplayName = (a: InvestmentEntity, b: InvestmentEntity) => {
  const displayName = a.display_name?.toLowerCase() ?? ''
  const otherDisplayName = b.display_name?.toLowerCase() ?? ''

  if (displayName < otherDisplayName) return -1
  if (displayName > otherDisplayName) return 1
  return 0
}

export const compareInvestmentEntitiesBySearchRank =
  (searchTextLower: string) => (a: InvestmentEntity, b: InvestmentEntity) => {
    if (searchTextLower) {
      if (a.symbol?.toLowerCase() === searchTextLower) return -1
      if (b.symbol?.toLowerCase() === searchTextLower) return 1
      if (a.display_name?.toLowerCase() === searchTextLower) return -1
      if (b.display_name?.toLowerCase() === searchTextLower) return 1
      if (a.symbol?.toLowerCase().startsWith(searchTextLower)) return -1
      if (b.symbol?.toLowerCase().startsWith(searchTextLower)) return 1
      if (a.display_name?.toLowerCase().startsWith(searchTextLower)) return -1
      if (b.display_name?.toLowerCase().startsWith(searchTextLower)) return 1
    }
    return compareInvestmentEntitiesByDisplayName(a, b)
  }

export const getTradableInvestmentEntitySearchResults = (
  allInvestmentEntities: InvestmentEntity[],
  searchText: string
) => {
  const searchTextLower = searchText.toLowerCase()
  return allInvestmentEntities
    .filter(isTradableInvestmentEntity)
    .filter(entity => matchesInvestmentEntitySearch(entity, searchTextLower))
    .sort(compareInvestmentEntitiesBySearchRank(searchTextLower))
}
